import { Seo, breadcrumbJsonLd, ORG_JSONLD } from "@/lib/Seo";
import { PageHeader } from "@/components/PageHeader";
import { ContactSection } from "@/sections/ContactSection";
import { FAQSection } from "@/sections/FAQSection";

const BREADCRUMB = [
  { name: "Home", path: "/" },
  { name: "Contact", path: "/contact" },
];

export default function ContactPage() {
  return (
    <>
      <Seo
        title="Contact | Brandpreventie Recycling"
        description="Neem contact op met Beveilig Alles B.V. over thermische branddetectie voor uw recyclingbedrijf. Bel 085-1307675 of mail naar info@beveiligalles.nl."
        jsonLd={[breadcrumbJsonLd(BREADCRUMB), ORG_JSONLD]}
      />
      <PageHeader
        overline="Contact"
        title="Neem contact op"
        intro="Landelijke levering, installatie en service in Nederland. We denken graag met u mee over de risicogebieden op uw terrein."
        breadcrumb={BREADCRUMB}
      />
      <ContactSection />
      <FAQSection limit={6} />
    </>
  );
}
